import React from 'react';

const THead = ({columns, columnDelete = false, columnUploadImages = false}) => {
  return (
    <thead>
      <tr>
        {Object.entries(columns).map(([key, value]) => (
          <th key={key}>{value}</th>
        ))}
        {columnDelete ? <th>Delete</th> : null}
        {columnUploadImages ? <th>Upload Images</th> : null}
      </tr>
    </thead>
  )
}

export default THead;



// WEBPACK FOOTER //
// ./src/new-components/admin/table/thead.js